import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router';

import useCurrentPath from 'common/hooks/useCurrentPath';

import * as routes from '../../routes';
import { FiltersProvider } from '../hooks/useFilters';
import AddPage from './pages/Add';
import EditPage from './pages/Edit';
import ListPage from './pages/List';
import { STATUSES } from './pages/List/constants';
import PreviewPage from './pages/Preview';

const Invoices: FC = () => {
  const { path } = useCurrentPath();

  return (
    <Switch>
      <Route exact path={path}>
        <FiltersProvider validStatuses={STATUSES}>
          <ListPage />
        </FiltersProvider>
      </Route>
      <Route component={AddPage} path={routes.addInvoice} />
      <Route component={EditPage} path={routes.editInvoice} />
      <Route component={PreviewPage} exact path={routes.previewInvoice} />

      <Route
        path={routes.legacyEditInvoice}
        render={({ match }) => (
          <Redirect to={routes.getEditInvoice(match.params.invoiceId ?? '')} />
        )}
      />
    </Switch>
  );
};

export default Invoices;
